var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.messageData ? 'print-view' : 'print-view-hidden',on:{"click":function($event){_vm.messageData = null}}},[_c('e-m-l-viewer',{ref:"emlView",attrs:{"printing":true},on:{"ready":_vm.printMail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }